import {v4 as uuidv4} from 'uuid';

export function generatekey({category = 'key'}) {
    return '@' + category + '-' + uuidv4();
}
